import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { getConfig, getCriancaAtiva, salvarConfig } from "../../db/queries";
import { idade } from "../../lib/format";

/** Configurações do Elo. Paciente e backup são compartilhados (ficam no Pitada). */
export function ConfigElo() {
  const nav = useNavigate();
  const cfg = useLiveQuery(getConfig);
  const crianca = useLiveQuery(getCriancaAtiva);
  const anos = idade(crianca?.data_nascimento ?? null);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>
      <h1 className="tela-titulo">configurações · Elo</h1>

      <section className="secao">
        <h2 className="secao-titulo">paciente</h2>
        <button className="card linha-alimento" onClick={() => nav("/paciente")} style={{ width: "100%" }}>
          <div className="foto" aria-hidden>👤</div>
          <div className="crescer">
            {crianca ? (
              <>
                <div className="nome">
                  {crianca.nome_completo || crianca.apelido}
                  {anos !== null && <span className="meta"> · {anos} {anos === 1 ? "ano" : "anos"}</span>}
                </div>
                <div className="meta">o cadastro é compartilhado entre os módulos</div>
              </>
            ) : (
              <>
                <div className="nome">completar cadastro</div>
                <div className="meta">paciente e responsável</div>
              </>
            )}
          </div>
          <span aria-hidden>→</span>
        </button>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">lembrete de coordenação</h2>
        <div className="card">
          <div className="campo" style={{ margin: 0 }}>
            <label>avisar quando uma disciplina ficar sem nota há (dias)</label>
            <input
              type="number"
              min={3}
              max={90}
              value={cfg?.elo_lembrete_dias ?? 14}
              onChange={(e) => salvarConfig({ elo_lembrete_dias: Number(e.target.value) })}
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">privacidade & sigilo</h2>
        <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>
          tudo fica neste aparelho, sem conta. anexos marcados como <strong>sensíveis</strong>
          (antes/depois) ficam fora do export. O compartilhamento entre profissionais
          (anel de cuidado, sincronização) é da Fase 2 — ainda não está ativo.
        </p>
      </section>
    </main>
  );
}
